import { cosvcAiClient } from './clients';

// type
import { AiArticleType, GETv1AiArticlesReturnResponse, ResponseAiArticleType } from '@fe-news/constants/ai/type';

/**
 * https://cosvc.api.beta.cnyes.cool/cosvc/api/v1/yushan_ai/article/summary/headline
 * @export 搜尋 AI 摘要新聞
 * @param {AIArticleType} type 類別
 * @returns {Promise<GETv1AIArticlesResponse>}
 */

const DEFAULT_AI_BASE_URL = '/cosvc/api/v1/yushan_ai/article/summary';
const DEFAULT_REVALIDATE_TIME = 600;

type GETAiNewsType = {
  type: AiArticleType;
};

export const GETAiNews = async ({ type }: GETAiNewsType): Promise<GETv1AiArticlesReturnResponse> => {
  const url = `${DEFAULT_AI_BASE_URL}/${type}`;

  try {
    const data = (await cosvcAiClient.get(url, {
      next: { revalidate: DEFAULT_REVALIDATE_TIME }
    })) as ResponseAiArticleType;

    const { items } = data;

    return {
      ...items,
      createdAt: items.created_at
    };
  } catch (error) {
    console.error(`[API Error]: GETAiNews ${type}`, error);
    throw error;
  }
};
